import { Icon } from '@ps/isp-web-component-library';
import { ChevronMediumDown } from '@ps/isp-web-component-library/icons/ChevronMediumDown';
import classNames from 'clsx';
import React from 'react';

import ElementWithCount from '../ElementWithCount/ElementWithCount';

import styles from './Title.scss';

interface Props {
  children: React.ReactElement;
  count: number | undefined;
  isOpen?: boolean;
}

const Title: React.FC<Props> = ({ children, count, isOpen = false }) => (
  <div className={classNames(styles.titleWrapper)}>
    <h3 className={styles.title}>
      <ElementWithCount count={count} element={children} />
    </h3>
    <Icon
      icon={ChevronMediumDown}
      className={classNames(styles.icon, { [styles.iconOpen]: isOpen })}
      size="x1"
    />
  </div>
);

export default Title;
